<!-- Met href een echte link: de rechtermuisklik geeft het browsermenu met
     "Openen in nieuw tabblad" (en Ctrl/middenklik werken ook); een gewone klik
     blijft binnen de app navigeren via de klik op het menu-item. -->
@if (href) {
  <a
    class="egi-navigation-item__label egi-navigation-item__link"
    [attr.href]="href"
    (click)="onLinkClick($event)"
  >{{ navigationItem.name }}</a>
} @else {
  <div class="egi-navigation-item__label">{{ navigationItem.name }}</div>
}

@if (navigationItem.isMenu) {
  <i eIcon [icon]="icon"></i>
}
<ng-content></ng-content>
